import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DailyForecast } from '../entities/weather/daily-forecast.model';
import { HourlyForecast } from '../entities/weather/hourly-forecast.model';
import { NextHourForecast } from '../entities/weather/next-hour-forecast.model';
import { BaseApi } from './base.api';

@Injectable({
  providedIn: 'root',
})
export class WeatherApi extends BaseApi {
  endpoint = 'weather';

  getNextHourForecast(): Observable<NextHourForecast> {
    const url = this.generateUrl('next-hour-forecast');
    return this.http.get<NextHourForecast>(url, { params: this.params });
  }

  getHourlyForecast(): Observable<HourlyForecast[]> {
    const url = this.generateUrl('hourly-forecast');
    return this.http.get<HourlyForecast[]>(url, { params: this.params });
  }

  getDailyForecast(): Observable<DailyForecast[]> {
    const url = this.generateUrl('daily-forecast');
    return this.http.get<DailyForecast[]>(url, { params: this.params });
  }

  private get params() {
    return { location: this.config.config.weatherLocation };
  }
}
